import { Link } from "react-router-dom";
import { Col, Form, Row } from "reactstrap";
import { H3, LI, UL } from "../../../../AbstractElements";
import { ShareIt } from "../../../../Constant";
import { PRODUCT_SOCIAL } from "../../../../Data/Ecommerce";

export const ProductSocial = () => {
  return (
    <>
      <Row>
        <Col md="4">
          <H3 className="product-title">{ShareIt}</H3>
        </Col>
        <Col md="8">
          <div className="product-icon">
            <UL className="product-social simple-list d-flex flex-row">
              {PRODUCT_SOCIAL.map((item, index) => (
                <LI className="d-inline-block" key={index}>
                  <Link to={item.link} target="_blank" className="text-end">
                    <i className={`ms-2 fa fa-${item.text}`}></i>
                  </Link>
                </LI>
              ))}
            </UL>
            <Form className="d-inline-block f-right"></Form>
          </div>
        </Col>
      </Row>
      <hr />
    </>
  );
};
